module.exports = __webpack_public_path__ + "img/FullbackLight.bf030801.jpg";